/**
 * @generated SignedSource<<bcc0b5c5ffe1423cec0c471be11102f3>>
 * @relayHash 70c92872d8ccc540bcc28f7f9fc3a1e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027

import type { ConcreteRequest } from 'relay-runtime';
export type StarButtonPageCardStarMutation$variables = {
  id: string;
};
export type StarButtonPageCardStarMutation$data = {
  readonly favouritePage: {
    readonly content: {
      readonly id: string | null;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null;
          } | null;
        } | null;
      };
    };
  } | null;
};
export type StarButtonPageCardStarMutation = {
  response: StarButtonPageCardStarMutation$data;
  variables: StarButtonPageCardStarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "favouritePageInput"
      }
    ],
    "concreteType": "FavouritePagePayload",
    "kind": "LinkedField",
    "name": "favouritePage",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "FavouritedSummary",
                    "kind": "LinkedField",
                    "name": "favourited",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StarButtonPageCardStarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StarButtonPageCardStarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70c92872d8ccc540bcc28f7f9fc3a1e4",
    "id": "4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027",
    "metadata": {},
    "name": "StarButtonPageCardStarMutation",
    "operationKind": "mutation",
    "text": "mutation StarButtonPageCardStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
  }
};
})();

(node as any).hash = "f8033abcb2133c170a7481a2b9cff941";

export default node;
